import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { Button, Divider, Modal } from "@skydio/rivet-ui";

import type { FC, JSX } from "react";
import type { ModalProps } from "@skydio/rivet-ui";

interface Props {
  confirmTitleText: string;
  additionalInfo?: JSX.Element;
  okText?: string;
  cancelText?: string;
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
  warning?: boolean;
  confirmLoading?: boolean;
  modalSize?: ModalProps["size"];
  scrollBehavior?: ModalProps["scrollBehavior"];
}

const ConfirmModal: FC<Props> = ({
  confirmTitleText,
  additionalInfo,
  okText,
  cancelText,
  visible,
  onClose,
  onOk,
  warning,
  confirmLoading,
  modalSize = "lg",
  scrollBehavior = "normal",
}) => {
  return (
    <Modal
      isOpen={visible}
      onClose={onClose}
      hideCloseButton
      size={modalSize}
      scrollBehavior={scrollBehavior}
    >
      <Modal.Content>
        <Modal.Header className="flex-row gap-5 pt-6">
          {warning && (
            <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500" />
          )}
          <div className="flex flex-col gap-2">
            <Modal.Title level={5} className="whitespace-normal">
              {confirmTitleText}
            </Modal.Title>
            {additionalInfo && <Modal.Description>{additionalInfo}</Modal.Description>}
          </div>
        </Modal.Header>
        <Divider />
        <Modal.Footer>
          <Button variant="default" onPress={onClose}>
            {cancelText ?? "Cancel"}
          </Button>
          <Button variant="primary" destructive={warning} isLoading={confirmLoading} onPress={onOk}>
            {okText ?? "OK"}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};

export default ConfirmModal;
